import { styled } from 'linaria/react';

export const ComplimentaryProductInfoBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-200);
  width: 100%;
`;
